import React, { useState } from 'react';
import {
  Box, Paper, Tab, Tabs,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import ButtonApp from 'Shared/Button';
import SageOrders from './SageOrders';
import SalesOrders from './SalesOrders';
import SalesBlockedOrders from './SalesOrders/SalesBlockedOrders';
import useStyles from './style';
import DeletedSalesOrders from './DeletedSalesOrders';
import NewOrder from './NewOrder';

const OrderList = () => {
  const { state } = useLocation();
  const [tab, setTab] = useState(state ? state.tab : 0);
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };
  const classes = useStyles();
  const [openNewOrder, setOpenNewOrder] = useState(false);

  const handleCloseNewOrderModal = () => {
    setOpenNewOrder(false);
  };

  const handleOpenNewOrderModal = () => {
    setOpenNewOrder(true);
  };
  return (
    <Paper elevation={0} classes={{ root: classes.paper }}>
      {openNewOrder && <NewOrder handleClose={handleCloseNewOrderModal} />}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Tabs
          value={tab}
          onChange={handleChange}
          textColor="primary"
          TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
        >
          <Tab
            classes={{
              root: classes.tab,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper,
            }}
            label="Mes commandes"
            value={0}
          />
          <Tab
            classes={{
              root: classes.tab,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper,
            }}
            label="Mes commandes brouillons"
            value={1}
          />
          <Tab
            classes={{
              root: classes.tab,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper,
            }}
            label="Mes commandes annulées"
            value={2}
          />
          <Tab
            classes={{
              root: classes.tab,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper,
            }}
            label="Mes commandes bloquées"
            value={3}
          />
        </Tabs>
        <ButtonApp
          style={{ marginTop: 10, marginBottom: 10 }}
          label="Créer une nouvelle commande"
          onClick={handleOpenNewOrderModal}
        />
      </Box>
      {tab === 0 && <SageOrders />}
      {tab === 1 && <SalesOrders />}
      {tab === 2 && <DeletedSalesOrders />}
      {tab === 3 && <SalesBlockedOrders />}
    </Paper>
  );
};

export default OrderList;
